import { useEffect, useState, useCallback } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'
import { Select, Modal, Button, Input as AntInput, Table } from 'antd'
import { PlusOutlined, SearchOutlined, EditOutlined } from '@ant-design/icons'
import requests from 'service/api'
import queryClient from 'config/tanstackQuery'
import { toast } from 'components/ui/use-toast'
import {GiWashingMachine} from "react-icons/gi"
import { Input } from 'components/form/input'
import useTemNewStore from 'store/client/temNewStore'
import AdditionalInstructions from './PrimeHomeWashing/Addition/AdditionalInstructions'
import Fabric from './PrimeHomeWashing/Fabric'
import WashingAdditionalInstructions from './PrimeHomeWashing/Addition/WashingAdditionalInstructions'
import Symbol from './PrimeHomeWashing/Symbol'

export default function PriceSizesHome({ idx, tab, setdepartmantIDD, setifinch, ifinch ,homeProducts,setHomeProducts,brrand}) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()
  
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isModalVisible2, setIsModalVisible2] = useState(false)
  const [selectedSizeIndex, setSelectedSizeIndex] = useState(null)
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false)
  const [priceModalIndex, setPriceModalIndex] = useState(null)
  const [modalFormData, setModalFormData] = useState({ name: '', description: '' })
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [editingProduct, setEditingProduct] = useState(null)
  const [searchText, setSearchText] = useState('')
  const [filteredProducts, setFilteredProducts] = useState([])

  const cacheData = queryClient.getQueryData(['/list', 'sizeGroup'])
  const { anotherValue } = useTemNewStore();

  
  // Pack field'larını initialize et
  useEffect(() => {
    if (values?.zaraHomeLabel12?.[idx]?.sizes && values.zaraHomeLabel12[idx].sizes.length > 0) {
      console.log("Sizes array bulundu, pack field'ları kontrol ediliyor...")
      
      // Her size için pack field'ı var mı kontrol et
      values.zaraHomeLabel12[idx].sizes.forEach((size, sizeIndex) => {
        if (size.pack === undefined) {
          console.log(`Size ${sizeIndex} için pack field'ı ekleniyor...`)
          setFieldValue(`zaraHomeLabel12[${idx}].sizes[${sizeIndex}].pack`, "")
        }
      })
    }
  }, [values?.zaraHomeLabel12?.[idx]?.sizes?.length, idx, setFieldValue])
 
  useEffect(() => {
    console.log("values.zaraHomeLabel12[idx].sizesssssssssssss",values.zaraHomeLabel12[idx].sizes)
  }, [values.zaraHomeLabel12[idx]?.sizes?.length])
  // --- AYNI IF: Pieces Number görünürlüğü ---
  const showPiecesNumber = !!(
    values?.zaraHomeLabel12?.[idx]?.referanceCode === '68bf8d5d2b0a17ff6fc37315' &&
    ['Object', 'Textile', 'Food contact'].includes(values?.zaraHomeLabel12?.[idx]?.cardType)
  );

  const showLabel10Pack = true;
  const Show5290DUVET = !!(
    values?.zaraHomeLabel12?.[idx]?.referanceCode === '68c8aac52e0a8308a3c61eb5' ||
    values?.zaraHomeLabel12?.[idx]?.referanceCode === '68d73fd228a54263b9295918' ||
    values?.zaraHomeLabel12?.[idx]?.referanceCode === '68e1183ac95569b4b9b19e23' ||
    values?.zaraHomeLabel12?.[idx]?.referanceCode === '68e5c73619c6f6a55ea0356a'
  );
  
const showReversible = !!(
  values?.zaraHomeLabel12?.[idx]?.referanceCode === '68e5c73619c6f6a55ea0356a'
);
  const getSizeDisplay = useCallback((item, findSizeData,setifinch,setdepartmantIDD,ifinch) => {
    if (item.cm || item.inches) {
      setifinch(true)
      return item.cm || item.inches;
    }
    if (item.europe || item.usa || item.mexico || item['br-brasil']) {
      const isCocuk = findSizeData?.name?.includes('ÇOCUK');
      const isBebek = findSizeData?.name?.includes('BEBEK');
      setifinch(false)
      if (isCocuk || isBebek) {
        return item.size?.split(' ')[0] || item.europe;
      }
      return item.europe || item.usa || item.mexico || item['br-brasil'];
    }
    return item.size || item.scode || '';
  }, [setifinch, setdepartmantIDD]);

  const getSizeDisplaySimple = (item, findSizeData) => {
    if (item.cm || item.inches) return item.cm || item.inches;
    if (item.europe || item.usa || item.mexico || item['br-brasil']) {
      const isCocuk = findSizeData?.name?.includes('ÇOCUK');
      const isBebek = findSizeData?.name?.includes('BEBEK');
      if (isCocuk || isBebek) return item.size?.split(' ')[0] || item.europe;
      return item.europe || item.usa || item.mexico || item['br-brasil'];
    }
    return item.size || item.scode || '';
  };

  const addCustomInch = () => {
    const currentSizes = [...values.zaraHomeLabel12[idx].sizes];
    currentSizes.push({
      name: '',
      amount: '',
      amountWithDefect: '',
      cn: '',
      sCode: '',
      isCustomInch: true
    });
    setFieldValue(`zaraHomeLabel12[${idx}].sizes`, currentSizes);
  };

  const handleSizeChange = (index, field, value) => {
    const newSizes = [...values.zaraHomeLabel12[idx].sizes]
    newSizes[index] = {
      ...newSizes[index],
      [field]: value,
      ...(field === 'inches' && !newSizes[index].usa && !newSizes[index].mexico && !newSizes[index]['br-brasil'] && {
        usa: value,
        mexico: value,
        'br-brasil': value
      })
    }
    setFieldValue(`zaraHomeLabel12[${idx}].sizes`, newSizes)
  }

  const showModal = () => {
    setIsModalVisible(true)
    setModalFormData({ name: '', description: '' })
  }
  const showModal2 = (currentIndex) => {
    setSelectedSizeIndex(currentIndex)
    setIsModalVisible2(true)
  }
  const handleModalOk = async () => {
    if (modalFormData.name.trim() && modalFormData.description.trim()) {
      try {
        const response = await requests.order.addZaraHomeProduct({
          name: modalFormData.name,
          text: modalFormData.description,
        });
        if (response.status === 201) {
          toast.success('Açıklama başarıyla kaydedildi');
          setIsModalVisible(false);
          setModalFormData({ name: '', description: '' });
          if (homeProducts) setFilteredProducts([...homeProducts]);
          if (setHomeProducts) setHomeProducts([...homeProducts]);
        } else {
          toast.error('Açıklama kaydedilemedi');
        }
      } catch (error) {
        console.error('API hatası:', error);
        toast.error('Bir hata oluştu');
      }
    }
  }

  const handleModalCancel = () => {
    setIsModalVisible(false)
    setModalFormData({ name: '', description: '' })
  }
  const handleModalCancel2 = () => {
    setIsModalVisible2(false)
    setSelectedSizeIndex(null)
  }

  const handleEditModalOk = async () => {
    if (editingProduct && editingProduct.name.trim() && editingProduct.text.trim()) {
      try {
        const response = await requests.order.updateZaraHomeProduct({
          id: editingProduct.id,
          name: editingProduct.name,
          text: editingProduct.text,
        });
        if (response.status === 200) {
          toast.success('Açıklama başarıyla güncellendi');
          setIsEditModalVisible(false);
          setEditingProduct(null);
          if (homeProducts) setFilteredProducts([...homeProducts]);
          if (setHomeProducts) setHomeProducts([...homeProducts]);
        } else {
          toast.error('Açıklama güncellenemedi');
        }
      } catch (error) {
        console.error('API hatası:', error);
        toast.error('Bir hata oluştu');
      }
    }
  }

  const handleEditModalCancel = () => {
    setIsEditModalVisible(false)
    setEditingProduct(null)
  }

  const handleProductEdit = (record) => {
    setEditingProduct({
      id: record.id,
      name: record.name,
      text: record.text || record.description || ''
    });
    setIsEditModalVisible(true);
  }

  const handleSearch = () => {
    if (!homeProducts) return;
    if (!searchText.trim()) {
      setFilteredProducts([...homeProducts]);
    } else {
      const filtered = homeProducts.filter(product =>
        product.name.toLowerCase().includes(searchText.toLowerCase()) ||
        (product.text && product.text.toLowerCase().includes(searchText.toLowerCase())) ||
        (product.description && product.description.toLowerCase().includes(searchText.toLowerCase()))
      );
      setFilteredProducts(filtered);
    }
  }

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    if (!e.target.value.trim()) setFilteredProducts(homeProducts || []);
  }

  useEffect(() => {
    if (homeProducts) setFilteredProducts([...homeProducts]);
  }, [homeProducts]);

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      render: (id) => {
        const idStr = String(id);
        return idStr.length > 8 ? `${idStr.substring(0, 8)}...` : idStr;
      }
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      render: (name) => {
        if (!name) return '-';
        return name.length > 25 ? `${name.substring(0, 25)}...` : name;
      }
    },
    {
      title: 'Açıklama',
      dataIndex: 'text',
      key: 'text',
      width: 300,
      render: (text, record) => {
        const description = text || record.description || '-';
        if (description === '-') return description;
        return description.length > 50 ? `${description.substring(0, 50)}...` : description;
      },
    },
    {
      title: 'İşlemler',
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Button
          type="primary"
          icon={<EditOutlined />}
          size="small"
          onClick={() => handleProductEdit(record)}
          style={{ backgroundColor: '#1890ff' }}
        >
          Düzenle
        </Button>
      ),
    },
  ];

  const normalizeMixed = (mixed) => {
    const arr = Array.isArray(mixed) ? mixed.slice(0, 4) : []
    for (let i = 0; i < 4; i += 1) {
      if (!arr[i]) {
        arr[i] = { currency: '', currencyType: undefined }
      } else {
        arr[i] = {
          currency: String(arr[i].currency || ''),
          currencyType: arr[i].currencyType || undefined,
        }
      }
    }
    return arr
  }

  useEffect(() => {
    const updateSizes = () => {
      if (!cacheData) return;
      const findSizeData = cacheData.find(item => item.id === values.sizeGroup);
      if (!findSizeData) return;
      setdepartmantIDD(findSizeData.id);

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData, setifinch, setdepartmantIDD, ifinch);

        const base = {
          name: item.scode,
          amount: '',
          amountWithDefect: '',
          cn: item.cnupperwoman || item.cm || '',
          sCode: item.scode || '',
          description: '',
          uid: item.uid,
          cardtypeXX: '',
          pillowtypeYY: '',
          carddesc: '',
          // Initialize empty arrays and objects for new sizes
          additionalPhrases: [],
          washingAdditionalPhrases: [],
          symbol: {},
          fabric: [],
          pack: ''
        };

        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode','amount','amountWithDefect','name'].includes(key) ||
            typeof item[key] !== 'string'
          ) return acc;

          acc[key] = item[key] || '';
          return acc;
        }, {});

        return { ...base, ...dynamicSizeFields };
      });

      setFieldValue(`zaraHomeLabel12[${idx}].sizes`, newSizes);
    };

    const updateSizes2 = () => {
      if (!cacheData) return;
      const findSizeData = cacheData.find(item => item.id === values.sizeGroup);
      if (!findSizeData) return;
      setdepartmantIDD(findSizeData.id);

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData, setifinch, setdepartmantIDD, ifinch);

        const prev = values.zaraHomeLabel12[idx]?.sizes[idx2] || {};
        const base = {
          name: item.scode,
          amount: prev.amount || '',
          amountWithDefect: prev.amountWithDefect || '',
          sCode: item.scode || '',
          description: prev.description || '',
          mixed: normalizeMixed(prev.mixed),
          uid: item.uid,
          cardtypeXX: prev.cardtypeXX || '',
          pillowtypeYY: prev.pillowtypeYY || '',
          carddesc: prev.carddesc || '',
          // Preserve existing data
          additionalPhrases: prev.additionalPhrases || [],
          washingAdditionalPhrases: prev.washingAdditionalPhrases || [],
          symbol: prev.symbol || {},
          fabric: prev.fabric || [],
          pack: prev.pack || ''
        };

        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode','amount','amountWithDefect','name'].includes(key) ||
            typeof item[key] !== 'string'
          ) return acc;

          acc[key] = item[key] || '';
          return acc;
        }, {});

        return { ...base, ...dynamicSizeFields };
      });

      setFieldValue(`zaraHomeLabel12[${idx}].sizes`, newSizes);
    };

    if (!orderNo || (orderNo && values.zaraHomeLabel12[idx]?.sizes?.length === 0)) {
      updateSizes();
    } else {
      updateSizes2();
    }
  }, [cacheData, orderNo, anotherValue, values.sizeGroup, idx, setFieldValue, getSizeDisplay]);

  const handleMixedChange = (sizeIndex, mixIdx, field, value) => {
    const sizesCopy = [...values.zaraHomeLabel12[idx].sizes]

    if (!sizesCopy[sizeIndex]) {
      sizesCopy[sizeIndex] = {
        name: '',
        amount: '',
        amountWithDefect: '',
        cn: '',
        sCode: '',
        description: '',
        mixed: [
          { currency: '', currencyType: undefined },
          { currency: '', currencyType: undefined },
          { currency: '', currencyType: undefined },
          { currency: '', currencyType: undefined },
        ]
      }
    }

    if (!sizesCopy[sizeIndex].mixed || !Array.isArray(sizesCopy[sizeIndex].mixed)) {
      sizesCopy[sizeIndex].mixed = [
        { currency: '', currencyType: undefined },
        { currency: '', currencyType: undefined },
        { currency: '', currencyType: undefined },
        { currency: '', currencyType: undefined },
      ]
    }

    if (!sizesCopy[sizeIndex].mixed[mixIdx]) {
      sizesCopy[sizeIndex].mixed[mixIdx] = { currency: '', currencyType: undefined }
    }

    const normalized = field === 'currency' ? value.replace(/,/g, '.') : value
    if (field === 'currency' && !( /^\d*\.?\d*$/.test(normalized) || value === '' )) {
      return
    }

    sizesCopy[sizeIndex].mixed[mixIdx][field] = field === 'currency' ? normalized : value
    setFieldValue(`zaraHomeLabel12[${idx}].sizes`, sizesCopy)
  }


  const showPriceModal = (index) => {
    if (index === 1) {
      setPriceModalIndex(index)
      setIsPriceModalVisible(true)
    }
  }

  const handlePriceModalCancel = () => {
    setIsPriceModalVisible(false)
    setPriceModalIndex(null)
  }

  // Para birimi seçenekleri (gerekirse genişlet)
  const currencyOptions1 = [{ label: 'EUR', value: 'EUR' }]
  const getCurrencyOptionsByMix = () => currencyOptions1

  return (
    <div className="rounded border border-dashed p-2">
      {/* Yatay taşma olursa kaydırılabilir alan */}
      <div className="w-full overflow-x-auto">
        <div
          className="mb-2 grid text-sm font-medium text-simsek"
          style={{
            // Pieces Number açıksa +1 kolon
            gridTemplateColumns: `repeat(${showPiecesNumber || showLabel10Pack ? 10 : 9}, minmax(0, 1fr))`,
            columnGap: '0.75rem',
            minWidth: '1100px' // sıkışmayı engelle; gerekirse arttır
          }}
        >
          <p>Beden</p>
          <p>Adet</p>
          <p>%</p>
          <p>Fireli Adet</p>
          <p>Açıklama</p>
          <p>Fiyat 1</p>
          <p>Fiyat 2</p>
          <p>Fiyat Türü</p>
          {showPiecesNumber && <p>Pieces Number</p>}
          {showLabel10Pack && <p>Pack</p>}
          <p>İşlem</p>
        </div>

        <div className="space-y-1 min-w-[1100px]">
          {values.zaraHomeLabel12[idx].sizes.length < 1 ? (
            <div className="bg-rose-400 rounded p-2 text-center my-4">
              <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
            </div>
          ) : (
            values.zaraHomeLabel12[idx].sizes.map((_, index) => {
              const amount = values.zaraHomeLabel12[idx].sizes[index]?.amount
              const percent =
                (values.zaraHomeLabel12[idx].sizes[index]?.amount *
                  values.zaraHomeLabel12[idx].sizeDefectivePercent) / 100 || 0
              const wastageQuantity = String(parseInt(amount) + parseInt(percent))

              return (
                <div
                  key={index}
                  className="grid"
                  style={{
                    gridTemplateColumns: `repeat(${showPiecesNumber || showLabel10Pack ? 10 : 9}, minmax(0, 1fr))`,
                    columnGap: '0.75rem'
                  }}
                >
                   {isModalVisible2 && selectedSizeIndex === index && (
                     <Modal
                       title="Yıkama Ekle Düzenle"
                       open={isModalVisible2}
                       onCancel={handleModalCancel2}
                       cancelText="İptal"
                       width={1400}
                       styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } }}
                       footer={[
                         <Button key="cancel" onClick={handleModalCancel2}>Ekrana Dön</Button>
                       ]}
                     >
                       <div style={{ marginBottom: '16px',display:'flex',flexDirection:'row',gap:10, alignItems:'flex-start' }}>
                 
                       </div>
                       <div
  style={{
    width: "100%",
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "16px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "8px", // biraz boşluk
  }}
>
 

  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      flex: "0 0 45%",
      gap: "8px",
    }}
  >
    {/* Kart Tipi Select */}
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <label
        style={{
          fontSize: "13px",
          fontWeight: 500,
          marginRight: "8px",
          marginLeft: 10,
        }}
      >
        KART TİPİ
      </label>
      <select
        name={`zaraHomeLabel12[${idx}].sizes[${index}].cardtypeXX`}
        value={values.zaraHomeLabel12?.[idx]?.sizes?.[index]?.cardtypeXX || ''}
        onChange={(e) => handleSizeChange(index, 'cardtypeXX', e.target.value)}
        style={{
          flex: 1,
          minWidth: 400,
          padding: "6px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        <option value="">Seçiniz</option>
        <option value="ADULT - FLAT SHEET">ADULT - FLAT SHEET</option>
        <option value="ADULT - DUVET COVER">ADULT - DUVET COVER</option>
        <option value="ADULT - FITTED BOTTOM SHEET">ADULT - FITTED BOTTOM SHEET</option>
        <option value="ADULT - PILLOW CASE">ADULT - PILLOW CASE</option>
        <option value="KIDS - DUVET COVER">KIDS DUVET COVER</option>
        <option value="KIDS - FLAT SHEET">KIDS FLAT SHEET</option>
        <option value="KIDS - FITTED BOTTOM SHEET">KIDS FITTED BOTTOM SHEET</option>
        <option value="KIDS - PILLOW CASE">KIDS PILLOW CASE</option>
      </select>
    </div>

    {/* Kart Açıklama Input */}



  </div>
</div>


                     </Modal>
                   )}
                  <Input
                    name={`zaraHomeLabel12[${idx}].sizes[${index}].name`}
                    disabled  
                    autoComplete="off"
                    onClick={() => showPriceModal(index)}
                    style={{ cursor: 'pointer' }}
                  />
                  <Input
                    name={`zaraHomeLabel12[${idx}].sizes[${index}].amount`}
                    onWheel={(e) => e.target.blur()}
                    autoComplete="off"
                    onChange={(e) => handleSizeChange(index, 'amount', e.target.value)}
                  />

                  <Input name={`zaraHomeLabel12[${idx}].sizeDefectivePercent`} autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`zaraHomeLabel12[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`zaraHomeLabel12[${idx}].sizeDefectivePercent`, n)
                  }}
                />




                  <Input
                    name={`zaraHomeLabel12[${idx}].sizes[${index}].amountWithDefect`}
                    autoComplete="off"
                    value={
                      values.zaraHomeLabel12[idx].sizes[index].amount.length === 0
                        ? ' '
                        : wastageQuantity
                    }
                    disabled
                  />
                  <Select
                    name={`zaraHomeLabel12[${idx}].sizes[${index}].description`}
                    placeholder="Açıklama seçiniz"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={homeProducts?.map(product => ({
                      value: product.id,
                      label: product.name
                    })) || []}
                    value={values.zaraHomeLabel12[idx].sizes[index]?.description || undefined}
                    onChange={(value) => handleSizeChange(index, 'description', value)}
                    style={{ width: '100%' }}
                  />
                  <AntInput
                    placeholder="Fiyat"
                    autoComplete="off"
                    value={values.zaraHomeLabel12[idx].sizes[index]?.mixed?.[0]?.currency || ''}
                    onChange={(e) => handleMixedChange(index, 0, 'currency', e.target.value)}
                  />
                  <AntInput
                    placeholder="Fiyat 2"
                    autoComplete="off"
                    value={values.zaraHomeLabel12[idx].sizes[index]?.mixed?.[1]?.currency || ''}
                    onChange={(e) => handleMixedChange(index, 1, 'currency', e.target.value)}
                  />
                  <Select
                    placeholder="Para Birimi"
                    options={getCurrencyOptionsByMix(index)}
                    allowClear
                    value={(values.zaraHomeLabel12[idx].sizes[index]?.mixed?.[0]?.currencyType) || undefined}
                    onChange={(val) => handleMixedChange(index, 0, 'currencyType', val)}
                    style={{ width: '100%' }}
                  />

                  {/* --- AYNI IF: Pieces Number hücresi --- */}
                  {showPiecesNumber && (
                    <Input
                      name={`zaraHomeLabel12[${idx}].sizes[${index}].piecesNumber`}
                      autoComplete="off"
                    />
                  )}
                  {showLabel10Pack && (
                    <div>
                       <Select
                name={`zaraHomeLabel12[${idx}].sizes[${index}].pack`}
                value={values.zaraHomeLabel12?.[idx]?.sizes?.[index]?.pack}
                onChange={(value) => {

                  
                  // setFieldValue ile kaydet
                  setFieldValue(`zaraHomeLabel12[${idx}].sizes[${index}].pack`, value)
                  
                  // Formik'in güncellenmesini bekle
                  setTimeout(() => {
                    console.log("Kayıt sonrası kontrol:", values.zaraHomeLabel12?.[idx]?.sizes?.[index]?.pack)
                    console.log("Tüm sizes array:", values.zaraHomeLabel12?.[idx]?.sizes)
                  }, 200)
                }}
                placeholder="Pack seçin"
                allowClear
                style={{ width: 120 }}
                options={[
                { value: "Pack 1", label: "Pack 1" },
                { value: "Pack 2", label: "Pack 2" },
                { value: "Pack 3", label: "Pack 3" },
              ]}
            />


                    </div>
                  )}

                  <div className="flex justify-flex-start">
                    <Button
                      type="primary"
                      shape="rectangle"
                      size="small"
                      icon={<PlusOutlined />}
                      onClick={showModal}
                      style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                    />
                    {Show5290DUVET && (
                      <Button
                      type="primary"
                      shape="rectangle"
                      size="small"
                      icon={<GiWashingMachine />}
                      onClick={() => showModal2(index)}
                      style={{ backgroundColor: 'rgb(7 83 134)', borderColor: 'rgb(7 83 134)',marginLeft:5 }}
                    />
                    )}
                  </div>
                </div>
              )
            })
          )}

          {values.zaraHomeLabel12[idx].sizes.length > 0 && (
            <div
              className="grid"
              style={{
                gridTemplateColumns: `repeat(${showPiecesNumber ? 10 : 9}, minmax(0, 1fr))`,
                columnGap: '0.75rem'
              }}
            >
              <p></p>
              <p className="text-sm font-semibold text-center">
                {values.zaraHomeLabel12[idx].sizes?.reduce((acc, curr) => {
                  if (curr.amount) return acc + parseInt(curr.amount)
                  return acc
                }, 0)}
              </p>
              <p></p>
              <p className="text-sm font-semibold text-center">
                {values.zaraHomeLabel12[idx].sizes?.reduce((acc, curr) => {
                  const a = curr.amountWithDefect
                  if (a && String(a).length > 1) return acc + parseInt(a)
                  return acc
                }, 0)}
              </p>
              <p></p>
              <p></p>
              <p></p>
              <p></p>
              {showPiecesNumber && <p></p>}
              <p></p>
            </div>
          )}
        </div>

        <div style={{ width:'100%', border: '1px solid #ccc', padding: '10px', borderRadius: '4px' }}>
                           <Fabric idx={idx} brrand={brrand} index="2" />
                         </div>

      </div>

      {/* Yeni Açıklama Ekle Modal */}
      <Modal
        title="Yeni Açıklama Ekle"
        open={isModalVisible}
        onCancel={handleModalCancel}
        cancelText="İptal"
        width={1000}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>İptal</Button>
        ]}
      >
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Açıklama Görünür İsim (Kartta Geçmeyen):
          </label>
          <AntInput
            placeholder="Açıklama adını giriniz"
            value={modalFormData.name}
            onChange={(e) => setModalFormData(prev => ({ ...prev, name: e.target.value }))}
          />
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Açıklama:
          </label>
          <AntInput.TextArea
            placeholder="Açıklama metnini giriniz"
            value={modalFormData.description}
            onChange={(e) => setModalFormData(prev => ({ ...prev, description: e.target.value }))}
            rows={4}
            style={{ resize: 'none', whiteSpace: 'nowrap', overflowX: 'auto', overflowY: 'hidden' }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 5, marginBottom: 20 }}>
          <Button
            type="primary"
            onClick={handleModalOk}
            disabled={!modalFormData.name.trim() || !modalFormData.description.trim()}
          >
            Yeni Açıklama Ekle
          </Button>
        </div>

        <div
          style={{
            border: '1px solid rgb(9, 78, 3)',
            padding: 10,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            borderRadius: 4
          }}
        >
          <h3 style={{ marginBottom: '16px', fontWeight: 'bold' }}>Mevcut Açıklamalar</h3>

          <div style={{ marginBottom: '16px', display: 'flex', gap: 8 }}>
            <AntInput
              placeholder="Açıklama ara..."
              value={searchText}
              onChange={handleSearchChange}
              style={{ flex: 1 }}
              onPressEnter={handleSearch}
            />
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            >
              Ara
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredProducts}
            rowKey="id"
            size="small"
            pagination={{
              pageSize: 5,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`,
            }}
            scroll={{ y: 300 }}
            onRow={(record) => ({
              onDoubleClick: () => handleProductEdit(record),
              style: { cursor: 'pointer' }
            })}
          />
        </div>
      </Modal>

      {/* Düzenleme Modal'ı */}
      <Modal
        title="Açıklama Düzenle"
        open={isEditModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleEditModalCancel}
        okText="Güncelle"
        cancelText="İptal"
        okButtonProps={{
          disabled: !editingProduct?.name?.trim() || !editingProduct?.text?.trim()
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Açıklama Görünür İsim:
          </label>
          <AntInput
            placeholder="Açıklama adını giriniz"
            value={editingProduct?.name || ''}
            onChange={(e) => setEditingProduct(prev => ({ ...prev, name: e.target.value }))}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Açıklama:
          </label>
          <AntInput.TextArea
            placeholder="Açıklama metnini giriniz"
            value={editingProduct?.text || ''}
            onChange={(e) => setEditingProduct(prev => ({ ...prev, text: e.target.value }))}
            rows={4}
            style={{ resize: 'none', whiteSpace: 'nowrap', overflowX: 'auto', overflowY: 'hidden' }}
          />
        </div>
      </Modal>
    </div>
  )
}
